var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsNewmedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.2 15.62c.1.61-.37 1.17-1.01 1.17a1 1 0 0 1-.99-.8l-1.04-4.56h-.45a.24.24 0 0 1-.24-.24V4.15c0-.13.1-.24.24-.24h3.14c.14 0 .24.1.24.24v7.07c0 .13-.1.24-.24.24h-.34l.69 4.16Zm7.81-13.47c-2.4 1.63-4.93 2.05-7.33 2.27v6.5c2.43.22 4.96.67 7.33 2.27.51.35.99.1.99-.61V2.76c0-.69-.48-.96-.99-.6ZM1 7.67a3.52 3.52 0 0 0 2.9 3.47V4.2A3.57 3.57 0 0 0 1 7.67Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsNewmedium);
export default __webpack_public_path__ + "static/media/whatsNew.medium.c12af0b376cc2bb9a200c1f928dfc4fc.svg";
export { ForwardRef as ReactComponent };